module.exports = __webpack_public_path__ + "static/img/kaishihuiyi.dcf00d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/kaishihuiyi.png
// module id = r3Xt
// module chunks = 24